import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { SITE, IMG } from "@/config/site";

const Block = ({ title, children }) => (
  <div className="border-t border-[#17251C]/14 py-8">
    <h2 className="display-xl text-xl text-[#17251C] md:text-2xl">{title}</h2>
    <div className="mt-4 space-y-3 text-base leading-relaxed text-[#6E7A69]">{children}</div>
  </div>
);

export default function Impressum() {
  return (
    <>
      <Seo
        title="Impressum | Hanse Garten Bremen"
        description="Impressum von Hanse Garten Bremen, Inhaber Salih Koluman, Große Weidestraße 2, 28195 Bremen."
        path="/impressum"
        image={IMG.logo}
      />
      <PageHero
        eyebrow="Rechtliches"
        titleLines={["Impressum"]}
        text="Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)."
        breadcrumb="Impressum"
      />

      <section className="bg-[#F3EDE2] py-20 md:py-28">
        <div className="mx-auto max-w-[900px] px-5 md:px-10">
          <Block title="Anbieter">
            <p>
              {SITE.name}
              <br />
              Inhaber: {SITE.owner}
              <br />
              Rechtsform: {SITE.legalForm}
            </p>
            <p>
              {SITE.street}
              <br />
              {SITE.zipCity}
              <br />
              {SITE.country}
            </p>
          </Block>

          <Block title="Kontakt">
            <p>
              E-Mail: {SITE.email}
              <br />
              WhatsApp: {SITE.whatsappNumber}
            </p>
            <p>
              Eine Telefonnummer wird ergänzt, sobald diese vorliegt. Sie erreichen uns per E-Mail, WhatsApp oder über
              das Anfrageformular dieser Website.
            </p>
          </Block>

          <Block title="Verantwortlich für den Inhalt">
            <p>
              {SITE.owner}, {SITE.street}, {SITE.zipCity}
            </p>
          </Block>

          <Block title="Umsatzsteuer-Identifikationsnummer">
            <p>
              Eine Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz liegt derzeit nicht vor bzw. wurde
              uns nicht zur Veröffentlichung mitgeteilt. Sie wird ergänzt, sobald sie verfügbar ist.
            </p>
          </Block>

          <Block title="Streitschlichtung">
            <p>
              Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Block>

          <Block title="Haftung für Inhalte">
            <p>
              Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
              überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
              Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>
          </Block>

          <Block title="Haftung für Links">
            <p>
              Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </Block>

          <Block title="Urheberrecht">
            <p>
              Die auf dieser Website veröffentlichten Inhalte und Bilder unterliegen dem deutschen Urheberrecht. Eine
              Vervielfältigung oder Verwendung außerhalb der gesetzlich zugelassenen Fälle bedarf der vorherigen
              schriftlichen Zustimmung.
            </p>
          </Block>
        </div>
      </section>
    </>
  );
}
